var _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.5594,
    cy: 28.2028,
    rx: 27.8953,
    ry: 27.5119,
    fill: "#E1F1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8558 24.2559C19.4578 12.975 36.4036 12.988 38.9924 24.269C40.5113 30.8864 36.3376 36.4878 32.679 39.9528C30.0242 42.4799 25.824 42.4799 23.156 39.9528C19.5106 36.4878 15.3369 30.8734 16.8558 24.2559Z",
    stroke: "#0063BF",
    strokeWidth: 2.21373
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.293 28.1765L26.2742 30.1305L31.5574 24.9199",
    stroke: "#0063BF",
    strokeWidth: 2.21373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a79f3a8b440202995e8b519bcfee1c94.svg";
export { ForwardRef as ReactComponent };